import {keyframes} from "@emotion/react";
import styled from "@emotion/styled";
import isPropValid from '@emotion/is-prop-valid';
import {mq} from "@styles/helpers";
import {Devices} from "@styles/tokens";

const scaleAnimation = keyframes`
    0% {
      transform: scale(0);
    }
    70% {
      transform: scale(1.5);
    }
    100% {
      transform: scale(1);
    }
`

export const Content = styled.div`
    position: relative;
    height:100%;
    width:100%;
    display:grid;
    grid-template-rows: 0.8fr 3.3fr 1.3fr;
`;

export const AnimationContainer = styled.div<{hide?:boolean}>`
    pointer-events: none;
    margin-top: auto;
    position: relative;
    height:100%;
    width:100%;
    z-index: 2;
`;

export const LottieContent = styled.div<{hide?:boolean, show?:boolean}>`
    pointer-events: none;
    margin-top: auto;
    position: relative;
    height:130%;
    width:100%;
    z-index: 2;
    transition: transform 1.5s cubic-bezier(0.075, 0.82, 0.165, 1);
    transform: scale(${props => props.show?"0":"1"});

    

    > div{
        position: absolute;
        top:50%;
        left:50%;
        transform: translate(-50%, -50%);
    }
`;

export const NewJar = styled.div<{size?:number, show?:boolean}>`
    width:100%;
    height: ${props => props.size === 2?"80%":props.size === 1?"70%":"60%"};
    top: ${props => props.size === 2?"25%":props.size === 1?"30%":"35%"}  !important;
    position: absolute;
    z-index: 4;
    opacity: 1 !important;
    transition: transform 3s cubic-bezier(0.075, 0.82, 0.165, 1);
    animation-name: ${scaleAnimation};
    animation-duration: 2s;
    animation-play-state: ${props => props.show?"running":"paused"};

    svg{
        width:100%;
        height:80%;
    }
`;

export const PointsContainer = styled.div<{hide?:boolean}>`
    display: flex;
    justify-content: center;
    position: absolute;
    top:15%;
    left:0;
    width:100%;
`;


export const CounterUnit = styled('div', {
    shouldForwardProp: (prop) => isPropValid(prop) && prop !== 'display' && prop !== 'roll',
})<{display?:boolean, roll?:boolean}>`
    display:${props => props.display?"none":"flex"};
    flex-direction: column;
    justify-content: start;

    transform: translateY(${props => props.roll?"-30px":"0"});
    transition: ${props => props.roll?"transform 200ms cubic-bezier(0.68, -0.55, 0.265, 1.55)":"unset"};
    width:13px;
    height:30px;
`;

export const CounterNumber = styled.div<{}>`
    font-size: clamp(12px, 4vw, 20px);
    font-weight: 700;
    line-height: 30px;
    text-align: center;
    width:13px;
`;